
module.exports = class ToolchestSessionsButton extends React.Component
  displayName: 'ToolchestSessionsButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'sessions_tools'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'

      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'sessions_tools', show_this: 'sessions_tools'}) }>
                    sessions
                </button>
            </h2>
            <p className="card-text">
                Create the conference sessions.
            </p>
        </div>
      </div>
